document.addEventListener('DOMContentLoaded', () => {
  const readMoreButton = document.querySelector('.read-more-button');
  const description = document.querySelector('.description');

  readMoreButton.addEventListener('click', () => {
    if (description.classList.contains('expanded')) {
      description.classList.remove('expanded');
      readMoreButton.innerHTML = '<span class="icon">+</span> Read more';
      window.scrollTo({
        top: description.offsetTop - 25, // Adjust scroll position
        behavior: 'smooth'
      });
    } else {
      description.classList.add('expanded');
      readMoreButton.innerHTML = '<span class="icon">-</span> Read less';
      window.scrollTo({
        top: description.offsetTop - 20, // Adjust scroll position
        behavior: 'smooth'
      });
    }
  });
});
